import EnPNG from './img/en.png'
import EsPNG from './img/spain.png'

interface LangOptions {
  lang: string
  icon: string
  text: string
  isArabic?: boolean
}

export type languagesType = 'en-US' | 'es-ES'

export const languagesForApi: { [key: string]: languagesType } = {
  'en-US': 'en-US',
  'es-ES': 'es-ES',
}

export const languages: { [key: string]: languagesType } = {
  EN: 'en-US',
  ES: 'es-ES',
}

export const languagesWithIcons: { [key in languagesType]: LangOptions } = {
  'en-US': { lang: languages.EN, icon: EnPNG, text: 'English' },
  'es-ES': { lang: languages.ES, icon: EsPNG, text: 'Español' },
}

export const shortLanguages: { [key in languagesType]: string } = {
  'en-US': 'en',
  'es-ES': 'es',
}

export const transLang: { [key in languagesType]: string } = {
  'en-US': 'en-US',
  'es-ES': 'es-ES',
}

export const languagesForHTML: { [key in languagesType]: string } = {
  'en-US': 'en',
  'es-ES': 'es',
}

export const defaultLanguage: languagesType = languages.ES
